/** @jsx React.createElement */
/** @jsxFrag React.Fragment */
import React from 'react';
import clsx from 'clsx';
import {Typography} from 'onboarding-components';

import styles from './index.module.styl';

type TileButtonBase = {
  selected?: boolean;
  fullWidthOnMobile?: boolean;
};

type ButtonProps = TileButtonBase & React.ButtonHTMLAttributes<HTMLButtonElement>;

export function TileButton({
  className,
  children,
  onClick,
  selected = false,
  fullWidthOnMobile = false,
  ...rest
}: ButtonProps) {
  return (
    <button
      className={clsx(
        styles.bubbleOption,
        fullWidthOnMobile && styles.optionFullWidth,
        selected && styles.selected,
        className,
      )}
      onClick={onClick}
      {...rest}
    >
      <Typography weight='bold' variant='captionSm'>
        {children}
      </Typography>
    </button>
  );
}
